import { render } from "./companyLicenses.vue?vue&type=template&id=3135f05e&ts=true"
import script from "./companyLicenses.vue?vue&type=script&lang=ts"
export * from "./companyLicenses.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__